<template>
  <div class="card no-body">
    <div class="card-header">
      <h5 class="h3 mb-0"> Jobs </h5>
    </div>

    <!-- Job Membership -->
    <div v-if="jobMembers">
        <b-list-group flush class="job-membership-list-group">
            <b-list-group-item v-for="item in jobMembersList" v-bind:key="item.jobId" class="d-flex justify-content-between align-items-center job-list-card">
                <router-link :to="{ name: 'Job Details', params: { jobId: item.jobId }}"><small>{{item.name ? item.name : 'No Name'}}</small></router-link>
                <span><small>{{$moment(item.dateStarted).calendar()}}</small></span>
            </b-list-group-item>
        </b-list-group>
    </div>
    <div v-else class="text-center p-3">
        <div v-if="loading"> Loading... </div>
        <div v-else> No jobs associated with this item </div>
    </div>

  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { JobGetRequest } from '#/protobuf/service_query_pb';

export default {
  props: {
    jobIds: {
      type: Array,
      description: 'The Job IDs to load',
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      loading: true,
      jobMembers: undefined, // for the job list once loaded.
    };
  },
  created() {
    this.loadJobMembers();
  },
  computed: {
    jobMembersList() {
      return this.jobMembers;
    },
  },
  methods: {
    ...mapActions('jobs', [
      'loadDetails',
    ]),
    async loadJobMembers() {
      if (!this.jobIds || this.jobIds.length === 0) {
        this.loading = false;
        return Promise.resolve();
      }
      console.log('loading job memebers', this.jobIds);
      const request = new JobGetRequest();
      request.setJobIdsList(this.jobIds.map((jobProto) => jobProto.getJobId()));
      return this.loadDetails(request).then((data) => {
        this.jobMembers = data.jobsList;
        console.log('loadJobMembers: ', this.jobMembers);
        this.loading = false;
      }).catch((error) => {
        console.log('Error loadJobMembers: ', error);
        this.loading = false;
      });
    },
  },
};
</script>
<style>
</style>
